<template>
  <div class="entrust-talbe" v-loading="!detailData.id">
    <table class="word-table">
      <tr>
        <td width="20%">
          <span class="label">项目名称</span>
        </td>
        <td width="30%">
          {{ detailData.projectName || '/' }}
        </td>
        <td width="20%">
          <span class="label">委托单位</span>
        </td>
        <td width="30%">
          {{ detailData.client }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">委托单位联系人</span>
        </td>
        <td>
          {{ detailData.sfcn }}
        </td>
        <td>
          <span class="label">联系方式</span>
        </td>
        <td>
          {{ detailData.sfcp }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">检测地点</span>
        </td>
        <td>{{ detailData.testAddress }}</td>
        <td>
          <span class="label">检测类别</span>
        </td>
        <td>
          {{ detailData.testTypeText }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">项目经理</span>
        </td>
        <td>{{ detailData.leaderName || '/' }}</td>
        <td>
          <span class="label">班组成员</span>
        </td>
        <td>
          {{ detailData.entrustmentUsers || '/' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">使用车辆</span>
        </td>
        <td :colspan="3">
          {{ detailData.supervisionUnit || '/' }}
        </td>
      </tr>
      <tr>
        <td width="20%">
          <span class="label">商定检测日期</span>
        </td>
        <td width="30%">
          {{ detailData.sendDate || '/' }}
        </td>
        <td width="20%">
          <span class="label">报告领取方式</span>
        </td>
        <td width="30%">
          {{ detailData.deliveryType == 0 ? '自取' : '邮寄（到付）' }}
        </td>
      </tr>
      <tr v-if="detailData.deliveryType == 1">
        <td width="20%">
          <span class="label">邮寄地址</span>
        </td>
        <td width="80%" :colspan="3" class="align-Left">
          {{ detailData.ivDdeliveryAddress }}
        </td>
      </tr>
      <tr>
        <td width="20%">
          <span class="label">客户备注</span>
        </td>
        <td width="80%" :colspan="3" class="align-Left">
          {{ detailData.note || '/' }}
        </td>
      </tr>
      <tr>
        <td width="20%">
          <span class="label">内部备注</span>
        </td>
        <td width="80%" :colspan="3" class="align-Left">
          {{ detailData.noteInner || '/' }}
        </td>
      </tr>
    </table>
    <table class="word-table">
      <tr>
        <td :colspan="6" class="label">试验信息</td>
      </tr>
      <tr>
        <td width="15%" class="label">检测项目</td>
        <td width="10%" class="label">样品数量</td>
        <td width="15%" class="label">试验项目</td>
        <td width="30%" class="label">现场图片</td>
        <td width="15%" class="label">检测清单</td>
        <td width="15%" class="label">工作量备注</td>
      </tr>
      <tr v-for="(item, index) in detailData.sampleInfoList" :key="index">
        <td class="align-Left">{{ item.testItemText }}</td>
        <td>{{ item.cnt }}</td>
        <td class="align-Left">
          {{ item.expItems }}
        </td>
        <td class="align-Left">
          <div class="img-list">
            <el-image
              v-for="(url, imgIndex) in item.imgList"
              :key="imgIndex"
              style="width: 88px; height: 88px"
              :src="url"
              :preview-src-list="item.imgList"
            ></el-image>
          </div>
        </td>
        <td class="align-Left">
          <el-link
            type="primary"
            :underline="true"
            v-for="(file, index) in item.files"
            :key="index"
            :href="`${$imgUrl}${file.filePath}`"
            target="_blank"
          >
            {{ file.fileName }}
          </el-link>
        </td>
        <td class="align-Left">{{ item.remark }}</td>
      </tr>
    </table>
    <table class="word-table">
      <tr>
        <td width="15%">
          <span class="label">检测项目</span>
        </td>
        <td width="85%" class="label">检测依据</td>
      </tr>
      <tr v-for="(item, index) in tesetItemData" :key="index">
        <td class="align-Left">
          <span>{{ item.itemName }}</span>
        </td>
        <td class="align-Left">{{ item.basis }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    tesetItemData() {
      if (this.detailData.basisTotalList && this.detailData.basisTotalList.length > 0) {
        const grouped = this.detailData.basisTotalList.reduce((acc, item) => {
          let group = acc.find(g => g.itemId === item.itemId);
          if (!group) {
            group = {
              itemId: item.itemId,
              itemName: item.itemName,
              basis: []
            };
            acc.push(group);
          }
          group.basis.push(item.basisName);
          return acc;
        }, []);

        // 将basis数组转为换行符连接的字符串
        grouped.forEach(group => {
          group.basis = group.basis.join('\n');
        });

        return grouped;
      } else {
        return [];
      }
    }
  },
  filters: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.img-list {
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
